import './Ticker.css';

function Ticker() {
  return (
    <div className="ticker">
      <div className="ticker-content">
        🍪 Secret Sale is Live - Code: RAIN50 |
        CODE: SHOP30 Shop any 2 products for upto 30% off |
        Pay Online for 2-3 Days Delivery upto 40% off 💪

        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

        🍪 Secret Sale is Live - Code: RAIN50 |
        CODE: SHOP30 Shop any 2 products for upto 30% off |
        Pay Online for 2-3 Days Delivery upto 40% off 💪
      </div>
    </div>
  );
}

export default Ticker;